import cn from "./lib/cn.js";
import us from "./lib/us.js";
import pr from "./lib/pr.js";
import lang1 from "element-ui/lib/locale/lang/en";
import lang2 from "element-ui/lib/locale/lang/zh-TW";
import lang3 from "element-ui/lib/locale/lang/pt";

export default {
  cn: {
    ...lang2,
    ...cn
  },
  us: {
    ...lang1,
    ...us
  },
  pr: {
    ...lang3,
    ...pr
  }
};